const M = 'M',
  C = 'C',
  L = 'L',
  DEFAULT_CURVATURE = 0.5,
  STATIC_LENGTH = 10,
  HORIZONTAL = 'horizontal',
  UNIFORM = 'uniform',
  horizontalRibbon = (source, target, curvature = DEFAULT_CURVATURE, type = UNIFORM) => {
    let x0, y0,
      x1, y1,
      sourceWidth = source.width,
      targetWidth = target.width,
      linePath,
      sy0, sy1,
      ty0, ty1,
      cx1, cy1,
      cx2, cy2;

    if (Math.abs(source.y - target.y) < 0.0001) {
      target.y += 0.0001;
    }

    x0 = source.x + STATIC_LENGTH;
    y0 = source.y;
    sy0 = y0 - sourceWidth / 2;
    sy1 = y0 + sourceWidth / 2;

    x1 = target.x - STATIC_LENGTH;
    y1 = target.y;
    ty0 = y1 - targetWidth / 2;
    ty1 = y1 + targetWidth / 2;

    if (x1 <= x0 || type !== UNIFORM) {
      x0 -= STATIC_LENGTH;
      x1 += STATIC_LENGTH;
    }

    cx1 = curvature * Math.abs(x1 - x0) + x0;
    cy1 = y0;

    cx2 = (1 - curvature) * Math.abs(x1 - x0) + x0;
    cy2 = y1;

    if (type === UNIFORM) {
      linePath = M + source.x + ',' + y0 + ' ' +
        L + x0 + ',' + y0 + ' ' +
        C + cx1 + ',' + cy1 + ' ' +
        cx2 + ',' + cy2 + ' ' +
        x1 + ',' + y1 + ' ' +
        L + target.x + ',' + y1;
    } else {
      linePath = M + x0 + ',' + sy0 + ' ' +
        L + x0 + ',' + sy0 + ' ' +
        C + cx1 + ',' + sy0 + ' ' +
        cx2 + ',' + ty0 + ' ' +
        x1 + ',' + ty0 + ' ' +
        L + x1 + ',' + ty1 + ' ' +
        C + cx2 + ',' + ty1 + ' ' +
        cx1 + ',' + sy1 + ' ' +
        x0 + ',' + sy1 + ' ' +
        L + x0 + ',' + sy0;
    }

    return linePath;
  },
  verticalRibbon = (source, target, curvature = DEFAULT_CURVATURE, type = UNIFORM) => {
    let x0, y0,
      x1, y1,
      linePath,
      sourceWidth = source.width,
      targetWidth = target.width,
      sx0, sx1,
      tx0, tx1,
      cx1, cy1,
      cx2, cy2;

    if (Math.abs(source.x - target.x) < 0.0001) {
      target.x += 0.0001;
    }

    x0 = source.x;
    sx0 = x0 - sourceWidth / 2;
    sx1 = x0 + sourceWidth / 2;
    y0 = source.y + STATIC_LENGTH;

    x1 = target.x;
    tx0 = x1 - targetWidth / 2;
    tx1 = x1 + targetWidth / 2;
    y1 = target.y - STATIC_LENGTH;

    if (y1 <= y0 || type !== UNIFORM) {
      y0 -= STATIC_LENGTH;
      y1 += STATIC_LENGTH;
    }

    cx1 = x0;
    cy1 = curvature * Math.abs(y1 - y0) + y0;

    cx2 = x1;
    cy2 = (1 - curvature) * Math.abs(y1 - y0) + y0;

    if (type === UNIFORM) {
      linePath = M + x0 + ',' + source.y + ' ' +
        L + x0 + ',' + y0 + ' ' +
        C + cx1 + ',' + cy1 + ' ' +
        cx2 + ',' + cy2 + ' ' +
        x1 + ',' + y1 + ' ' +
        L + x1 + ',' + target.y;
    } else {
      linePath = M + sx0 + ',' + y0 + ' ' +
        L + sx0 + ',' + y0 + ' ' +
        C + sx0 + ',' + cy1 + ' ' +
        tx0 + ',' + cy2 + ' ' +
        tx0 + ',' + y1 + ' ' +
        L + tx1 + ',' + y1 + ' ' +
        C + tx1 + ',' + cy2 + ' ' +
        sx1 + ',' + cy1 + ' ' +
        sx1 + ',' + y0 + ' ' +
        L + sx0 + ',' + y0;
    }

    return linePath;
  },
  sankeyRibbon = (source, target, config) => {
    let {
      curvature,
      orientation,
      padding,
      linkType
    } = config;

    orientation = orientation || HORIZONTAL;

    if (orientation === HORIZONTAL) {
      source.x = Math.floor(source.x + padding);
      target.x = Math.ceil(target.x - padding);
      return horizontalRibbon(source, target, curvature, linkType);
    }
    source.y = Math.floor(source.y + padding);
    target.y = Math.ceil(target.y - padding);
    return verticalRibbon(source, target, curvature, linkType);
  };

export {
  sankeyRibbon
};
